import React, { Component, Fragment } from 'react'
import VerLoginTabset from './ver-loginTabset';
import { ArrowLeft, Sliders } from 'react-feather';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import stats from '../../assets/images/dashboard/stats.png';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AuthService from "../services/auth.service";
import { isSessionValid } from "../services/session";

export class VerLogin extends Component {

    componentWillMount() {
        if (AuthService.getCurrentUser()) {
            if (isSessionValid()) {
                this.props.history.push("/category")
                window.location.reload();
            } else {
                // Token vencido guardado: antes mandaba a /category y todo fallaba en silencio
                AuthService.logout();
            }
        }
    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            arrows: false
        };
        return (
            <Fragment>
                <div className="page-wrapper">
                    <div className="authentication-box">
                        <div className="container">
                            <div className="row" className="login-content">
                                {/*<div className="col-md-5 p-0 card-left">
                                    <div className="card bg-primary">
                                        <div className="svg-icon">
                                            <img src={stats} className="Img-fluid" />
                                        </div>
                                        <Slider className="single-item" {...settings}>
                                            <div>
                                                <div>
                                                    <h3>Welcome to Multikart</h3>
                                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <h3>Welcome to Multikart</h3>
                                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div>
                                                    <h3>Welcome to Multikart</h3>
                                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
                                                </div>
                                            </div>
                                        </Slider >
                                    </div>
                                </div>*/}
                                <div className="col-md-7 p-0 card-right card-login">
                                    <div className="card tab2-card">
                                        <div className="card-body">
                                            {/expired=1/.test(this.props.location.search) && (
                                                <div className="alert alert-warning" style={{ fontSize: 14 }}>
                                                    Tu sesión expiró. Vuelve a iniciar sesión.
                                                </div>
                                            )}
                                            <VerLoginTabset />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/*<a href="https://react.pixelstrap.com/multikart" target="_blank" className="btn btn-primary back-btn"><ArrowLeft />back</a>*/}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default VerLogin
